import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import MaritalStatusForm from '../../components/Forms/MaritalStatusForm';
import { HeadingSubtitle } from '../../components/Heading';
import SaveAndCloseModal from '../../components/Modals/SaveAndCloseModal/SaveAndCloseModal';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import Paragraph from '../../components/Paragraph/Paragraph';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const SecureAccountRetirementMaritalStatus = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { BrokerName } = useSelector(selectSettings);
  const [eventType, setEventType] = useState('NoForm');
  const [saveAndCloseModalOpen, setSaveAndCloseModalOpen] = useState(false);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      setEventType={setEventType}
      eventType={eventType}
      setSaveAndCloseModalOpen={setSaveAndCloseModalOpen}
    >
      <Helmet>
        <title>
          {t('titleTagMarital', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={12} color={themeColors.colorTextSecondary}>
        {t('retirementMaritalStatus.title')}
      </HeadingSubtitle>
      <Paragraph mb={32} color={themeColors.colorTextXLLight}>
        {t('retirementMaritalStatus.subtitle')}
      </Paragraph>
      <MaritalStatusForm nextPath={activeItem?.nextPath} />
      {saveAndCloseModalOpen && (
        <SaveAndCloseModal
          isOpen={saveAndCloseModalOpen}
          onClose={() => setSaveAndCloseModalOpen(false)}
        />
      )}
    </OnBoardingContainer>
  );
};

export default SecureAccountRetirementMaritalStatus;
